import * as authAPI from '@debbie/cortex/dist/api/auth.js';
import React, { useState } from 'react';
import { Button, Input } from '../index.js';
const SSOLogin = (props) => {
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const login = async () => {
        setLoading(true);
        try {
            const ssoUrl = await authAPI.ssoLogin(email.trim());
            window.location.href = ssoUrl.ssoUrl;
        }
        catch (err) {
            console.error(err);
            setError(err?.message);
            setLoading(false);
        }
    };
    return (React.createElement("div", null,
        error !== '' ? React.createElement("div", { className: "warning" }, error) : null,
        React.createElement(Input, { placeholder: "E-mail", value: email, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    login();
                }
            }, onChange: (e) => {
                setEmail(e.target.value);
            } }),
        React.createElement(Button, { block: true, style: { marginBottom: '10px' }, loading: loading, onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                login();
            } }, "Log ind"),
        React.createElement(Button, { block: true, onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onCancel();
            }, theme: "secondary" }, "Annuller")));
};
export default SSOLogin;
//# sourceMappingURL=SSOLogin.js.map